/* @flow */

import React from 'react';
import { connect } from 'react-redux';
import PropTypes from '../util/prop_types';
import { SidePanelSelectors } from '../stores/sidepanel_selectors';
import { SidePanelActionCreators } from '../stores/sidepanel_action_creators';
import { keyCodes } from '../util/keycodes';

const mapStateToProps = (state) => {
  return {
    activeId: SidePanelSelectors.getActiveId(state),
  }
}

const mapDispatchToProps = {
  setActiveId: SidePanelActionCreators.setActiveId,
};

class SearchResultItem extends React.Component {
  static propTypes = {
    isActive: PropTypes.bool.isRequired,
    markerId: PropTypes.number.isRequired,
    result: PropTypes.object.isRequired,
    onSelection: PropTypes.func.isRequired,
    onFocus: PropTypes.func.isRequired,
    onBlur: PropTypes.func.isRequired,
    setActiveId: PropTypes.func.isRequired,
  }

  componentDidUpdate(prevProps) {
    if(prevProps.activeId != this.props.activeId && this.props.isActive) {
      this.elm.focus();
    }
  }

  onKeyUp = (e) => {
    if(e.keyCode == keyCodes.enter) {
      this.props.onSelection();
    }
    else if (e.keyCode == keyCodes.down) {
      this.props.setActiveId(this.props.activeId + 1);
    }
    else if (e.keyCode == keyCodes.up) {
      this.props.setActiveId(this.props.activeId - 1);
    }
  }

  getBody(): ?React.Element<any> {
    var templateName = null;
    if (this.props.result.item.id) {
      templateName = this.props.result.item.id.split('-', 1)[0];
    }

    var item = this.props.result.item;
    switch (templateName) {
      case "prk": {
        if ("name" in item.properties) {
          return (
            <div className="result-content">
              <div className="result-name">
                {item.properties.name}
              </div>
              <div className="result-subtext">
                Parking Lot {item.properties.old_name}
                {item.properties.zone_color &&
                  <span> - {item.properties.zone_color} Zone</span>
                }
              </div>
            </div>
          );
        }
        else {
          return (
            <div className="result-content">
              <div className="result-name">
                Parking Lot {item.properties.old_name}
              </div>
              {item.properties.zone_color &&
                <div className="result-subtext">
                  {item.properties.zone_color} Zone
                </div>
              }
            </div>
          );
        }
      }
      case "bldg": {
        var subtext = item.properties.ref_en || item.properties.ref || null;
        return (
          <div className="result-content">
            <div className="result-name">
              {item.properties.name}
            </div>
            {subtext &&
              <div className="result-subtext">
                {subtext}
              </div>
            }
          </div>
        );
      }
      default: {
        return (
          <div className="result-content">
            <div className="result-name">
              {item.properties.name}
            </div>
          </div>
        );
      }
    }
  }

  render(): ?React.Element<any> {
    const { props } = this;

    return (
      <li role="option"
        tabIndex={props.isActive ? "0" : "-1"}
        onClick={props.onSelection}
        onKeyUp={this.onKeyUp}
        onMouseEnter={props.onFocus}
        onMouseLeave={props.onBlur}
        onFocus={props.onFocus}
        onBlur={props.onBlur}
        ref={(elm) => { this.elm = elm; }}>
        {/*<div className="result-id">
          {props.markerId}
        </div>*/}
        {this.getBody()}
      </li>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(SearchResultItem);
